export default __webpack_public_path__ + "static/ReaganKang-a956c52f029858b0801c7e8f05abeb8c.png";